import { useEffect } from "react";
import CmsBanner from "../../components/Banner/CmsBanner";
import { useCmsPage } from "../../hooks/useCms";
import Loader from "../../components/Loader/Loader";
import { useTranslation } from "react-i18next";

export default function PrivacyPolicy() {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  const { page, isLoading, isError } = useCmsPage("privacy_policy");

  useEffect(() => {
    const handleResize = () => {
      const body = document.body;

      if (window.innerWidth >= 2400) {
        body.classList.add("scale-wrapper");
      } else {
        body.classList.remove("scale-wrapper");
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (isLoading) {
    return (
      <div className="wrapper bg-primary-ivory">
        <CmsBanner
          classNameShape="hidden"
          title={t("privacyPolicy.title")}
          description={t("privacyPolicy.description")}
        />
        <section className="lg:py-20 lg:pb-25 py-10 pb-18 relative">
          <div className="w-full max-w-[900px] fullhd:max-w-[1100px] mx-auto px-4 relative z-20">
            <div className="flex flex-col items-center justify-center py-20">
              <Loader />
              <p className="mt-4 text-gray-600 text-lg font-medium">{t("privacyPolicy.loading")}</p>
            </div>
          </div>
        </section>
      </div>
    );
  }

  if (isError || !page) {
    return (
      <div className="wrapper bg-primary-ivory">
        <CmsBanner
          classNameShape="hidden"
          title={t("privacyPolicy.title")}
          description={t("privacyPolicy.description")}
        />
        <div className="w-full max-w-[900px] fullhd:max-w-[1100px] mx-auto px-4 relative z-20">
          <div className="flex flex-col items-center justify-center py-20">
            <p className="mt-4 text-gray-600 text-lg font-medium">{t("privacyPolicy.notAvailable")}</p>
            <p className="mt-4 text-gray-600 text-lg font-medium">{t("privacyPolicy.notAvailableDescription")}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="wrapper bg-primary-ivory">
      <CmsBanner
        classNameShape="hidden"
        title={page?.title || t("privacyPolicy.title")}
        description={t("privacyPolicy.description")}
      />
      <section className="lg:py-[3vw]  pb-22 relative  2xl:-mt-[2.24vw] -mt-11 z-10 ">
        <div className="w-full 2xl:max-w-[50vw] max-w-[900px] mx-auto px-4 relative z-20">
          <div
            className={`prose max-w-none ${isArabic ? "rtl text-right" : "ltr text-left"}`}
            dir={isArabic ? "rtl" : "ltr"}
          >
            <div dangerouslySetInnerHTML={{ __html: page?.content || "" }} />
          </div>
        </div>
      </section>
    </div>
  );
}
